import { render, staticRenderFns } from "./NotificationDPW.vue?vue&type=template&id=6497e22b"
import script from "./NotificationDPW.vue?vue&type=script&lang=js"
export * from "./NotificationDPW.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports